import React, { useState } from 'react';
import { Info, InsertCommentOutlined } from '@mui/icons-material';

import { FormModal, FormModalSubHeader, FormModalPaddedBody, ModalButtonRow, ModalButton } from 'components/ui/FormModal';
import InfoModal from 'components/ui/InfoModal';
import { setDocumentClarification } from "shared/services/railDocumentsApi";
import { DocumentComment } from 'shared/models/api/models';
import './Viewer.css'

type ClarifyModalProps = {
    documentId: number,
    commentMaxLength: number,
    isOpen: boolean,
    closeAction: () => void,
    submitAction: () => void
}

export const ClarifyModal = (props: ClarifyModalProps) => {
    const [clarifyNoMessageModalDisplayed, setClarifyNoMessageModalDisplayed] = useState(false);
    const [commentsText, setCommentsText] = useState('');

    const answerUpdate = (event: any) => {
        let value = (event?.target?.value || '').substring(0, props.commentMaxLength) as string;
        setCommentsText(value);
    }

    const submit = () => {
        if (commentsText.length < 1) {
            setClarifyNoMessageModalDisplayed(true);
            return;
        }

        const comments: DocumentComment = { text: commentsText };

        setDocumentClarification(props.documentId, comments).then(() => props.submitAction());
    }

    return (
        <FormModal {...props} icon={<InsertCommentOutlined />} headingText="Clarification request">
            <InfoModal
                text={'Please type in your message \n and try again.'}
                isOpen={clarifyNoMessageModalDisplayed}
                closeAction={() => { setClarifyNoMessageModalDisplayed(false); }}
            />
            <FormModalSubHeader>
                <div>Add a comment to this document</div>
            </FormModalSubHeader>

            <FormModalPaddedBody>

                <div className="modal-body-content-container">

                    <div className="modal-body-content-icon">
                        <Info className="info-icon" />
                    </div>

                    <div className="modal-body-content">

                        <div>Your comment will be recorded and be visible to supervisors.</div>
                        <div>If you don't want to send a clarification request, please close this window.</div>

                        <textarea
                            className="form-text"
                            placeholder="Type in your comments..."
                            value={commentsText}
                            maxLength={props.commentMaxLength}
                            onChange={answerUpdate} />

                        <ModalButtonRow>
                            <ModalButton onClick={props.closeAction} text="Cancel" />
                            <ModalButton onClick={submit} text="Submit" primaryButton={true} />
                        </ModalButtonRow>

                    </div>

                </div>

            </FormModalPaddedBody>

        </FormModal>
    );
}
